import React, { Fragment } from "react";
import {
  Tooltip,
  Position,
  NonIdealState,
  Intent,
  Button,
  InputGroup,
  HTMLSelect,
  Menu,
  MenuDivider,
  MenuItem,
  Popover,
} from "@blueprintjs/core";
// import { NumberProperties } from "docx";
import RessourceFullscreenable from "../../Sequences/RessourceFullscreenable";
import "../../../../assets/components/TableRessource.css";
import DialogAddAttribute from "../../Sequences/DialogAddAttribute";
import Auth from "../../../../services/Auth";
import firebase from "firebase";

class TableResources extends React.Component {
  state = {
    loading: true,
    customAttrDialog: false,
    attributesList: [],
  };

  handleDeleteResource = async (id) => {
    this.props.onDeleteResource(id);
  };

  handleDeleteAttribute = async (attribute, index) => {
    this.props.handleDeleteAttribute(attribute, index, this.props.number);
  };

  handleChange = (e) => {
    const { handleEditResource } = this.props;

    handleEditResource(e.target.value, e.target.name, e.target.id);
  };

  moreAttributes = (e) => {
    e.preventDefault();
    if (this.props.attributes) {
      this.props.handleChangeAttribute(
        "UNK",
        "UNK",
        "UNK",
        this.props.attributes.length,
        this.props.number
      );
      this.props.resources.forEach((ress, i) => {
        this.props.handleChangeAttributeUnitValue(
          "",
          this.props.attributes.length,
          i,
          this.props.number
        );
      });
    } else {
      this.props.handleChangeAttribute(
        "UNK",
        "UNK",
        "UNK",
        0,
        this.props.number
      );
      this.props.resources.forEach((ress, i) => {
        this.props.handleChangeAttributeUnitValue("", 0, i, this.props.number);
      });
    }
  };

  handleChangeResourcesOrder = async (currentIndex, newIndex) => {
    let { handleChangeSequencesResourcesCM, resources = [] } = this.props;

    resources.splice(newIndex, 0, resources.splice(currentIndex, 1)[0]);
    await handleChangeSequencesResourcesCM(this.props.number, resources);
    this.refreshAttributesList();
  };

  orderButton = (imageId) => {
    const { resources } = this.props;
    const index = resources.findIndex((i) => i.id === imageId);
    const orderMenu = (
      <Menu>
        <MenuDivider title="Change position" />
        {resources.map((element, newIndex) => {
          return (
            <MenuItem
              key={newIndex}
              text={newIndex + 1}
              disabled={index === newIndex}
              onClick={() => this.handleChangeResourcesOrder(index, newIndex)}
            />
          );
        })}
      </Menu>
    );
    return (
      <Popover content={orderMenu} position={Position.LEFT}>
        <Button icon="exchange" large={true} />
      </Popover>
    );
  };

  refreshAttributesList = async () => {
    this.setState({ loading: true });
    let attrs;
    let that = this;
    var ref = firebase.database().ref(`users/${Auth.getUser().uid}/attributes`);
    ref.on("value", function (snapshot) {
      attrs = snapshot.val();
      attrs.sort((a, b) => a.name.localeCompare(b.name));
      that.setState({ attributesList: attrs, loading: false });
    });
  };

  componentDidMount() {
    this.refreshAttributesList();
  }

  render() {
    const {
      resources,
      //  deleting,
      onOpenDialog,
      instances = [],
      attributes = [],
    } = this.props;
    let fileNumber = resources.length;

    let imageSize = 1;
    if (fileNumber > 3) {
      imageSize = 0.63;
    }

    if (resources.length <= 0)
      return (
        <NonIdealState
          icon="media"
          title="No images yet"
          description="You have to download images to create sequences"
          action={
            <Button
              text="Download images"
              rightIcon="cloud-upload"
              onClick={onOpenDialog}
              intent={Intent.PRIMARY}
            />
          }
        />
      );
    if (this.state.loading) {
      return <></>;
    } else {
      return (
        <div>
          <DialogAddAttribute
            dialogIsOpen={this.state.customAttrDialog}
            onCloseDialog={() => this.setState({ customAttrDialog: false })}
            addAttribute={() => console.log("test")}
            attributes={this.state.attributesList}
            refreshAttributesList={this.refreshAttributesList}
          />
          <div className="text-right">
            <Tooltip
              disabled={resources.length < 6}
              content="Vous avez atteint la limite maximale d'images"
              position={Position.TOP_LEFT}
            >
              <Button
                intent={Intent.PRIMARY}
                disabled={resources.length >= 6 || instances.length !== 0}
                rightIcon="cloud-upload"
                text="Download image"
                style={{ marginBottom: "20px" }}
                onClick={onOpenDialog}
              />
            </Tooltip>
          </div>
          <div>
            <div className="bp3-html-table full-width">
              <div className="newfiles-container">
                <div
                  className={fileNumber > 3 ? "margin-img-sm" : "margin-img-lg"}
                ></div>
                <div className="right-container">
                  {resources.map((r, i) => (
                    <Fragment key={i}>
                      {r.type === "VIDEO" && (
                        <a
                          className="margin-bottom-medium"
                          // eslint-disable-next-line
                          target="_blank"
                          href={r.downloadURL}
                        >
                          <Button text="Voir la vidéo" />
                        </a>
                      )}
                      {r.type === "IMAGE" && (
                        <RessourceFullscreenable
                          customClass={
                            fileNumber > 3 ? "delete-image" : "delete-image-sm"
                          }
                          handleDeleteResource={this.handleDeleteResource}
                          imageSize={imageSize}
                          downloadURL={r.downloadURL}
                          index={i}
                          id={r.id}
                          fileNumber={fileNumber}
                        />
                        // <div className="image-container hidden-xs hidden-sm">
                        //     <img className='margin-bottom-medium' width={266 * imageSize} height={150 * imageSize} src={r.downloadURL} alt={`resouce${i}`} />
                        //     <div className={fileNumber > 3 ? 'delete-image' : 'delete-image-sm'} onClick={() => this.handleDeleteResource(r.id)}>X</div>
                        // </div>
                      )}
                    </Fragment>
                  ))}
                </div>
                <div></div>
                <div className="align-center">
                  Image Name <br />
                  <br />
                  <br />
                  <br />
                  Change Image Order
                </div>
                <div className="right-container">
                  {resources.map((r, i) => (
                    <div key={i}>
                      <InputGroup
                        className="images-inputs"
                        id={i}
                        onChange={this.handleChange}
                        name="name"
                        defaultValue={r.name}
                      />
                      <br />
                      <br />
                      <div className="text-center">
                        {this.orderButton(r.id)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <br />
              <hr className="hidden-xs hidden-sm" />
              <br />
              <div className="newfiles-container">
                {attributes &&
                  attributes.map((attribute, attr) => (
                    <Fragment key={attr}>
                      <div className="attribute-container">
                        <HTMLSelect
                          fill={true}
                          name="attributes"
                          defaultValue={attribute.ref || "UNK"}
                          onChange={(e) => {
                            let myAttribute = this.state.attributesList.find(
                              (a) => a.ref === parseInt(e.target.value)
                            );
                            this.props.handleChangeAttribute(
                              myAttribute.name,
                              myAttribute.unit,
                              e.target.value.toString(),
                              attr,
                              this.props.number
                            );
                          }}
                          className="images-inputs"
                        >
                          <option disabled value="UNK">
                            Choose an attribute
                          </option>
                          {this.state.attributesList.map((userAttr, index) => (
                            <option key={index} value={userAttr.ref}>
                              {userAttr.name} - {userAttr.unit}
                            </option>
                          ))}
                        </HTMLSelect>
                      </div>
                      <div className="right-container">
                        {resources &&
                          resources.map((r, ress) => (
                            <div key={ress}>
                              <InputGroup
                                key={ress}
                                className="images-inputs"
                                id="input-right"
                                onChange={(e) =>
                                  this.props.handleChangeAttributeUnitValue(
                                    e.target.value,
                                    attr,
                                    ress,
                                    this.props.number
                                  )
                                }
                                name="quantity"
                                type="number"
                                step="0,001"
                                placeholder="xx,xx"
                                defaultValue={
                                  r.attributes && r.attributes[attr]
                                    ? r.attributes[attr].quantity
                                    : 0
                                }
                              />
                            </div>
                          ))}
                      </div>
                      <div
                        className="bp3-icon-large bp3-icon-trash trash"
                        onClick={() =>
                          this.handleDeleteAttribute(attribute, attr)
                        }
                      ></div>
                    </Fragment>
                  ))}
              </div>
              <br />
              <br />
              <Button
                intent={Intent.PRIMARY}
                value="UNK"
                onClick={this.moreAttributes}
              >
                Add attribute
              </Button>
              <br />
              <br />
              <Button
                intent={Intent.PRIMARY}
                value="UNK"
                onClick={() => this.setState({ customAttrDialog: true })}
              >
                Create custom attribute
              </Button>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default TableResources;
